import { useEffect, useState } from "react";
import {
  Container,
  Card,
  TextInput,
  Button,
  Loader,
  Title,
  Box,
} from "@mantine/core";
import { Formik, Form } from "formik";
import { AxiosFetch } from "../../components/Axios/AxiosFetch";
import { DataTable } from "mantine-datatable";

export default function CustomerSearch() {
  const axiosFetch = AxiosFetch();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  // ✅ Fetch customers (FIXED)
  const fetchCustomers = async (values) => {
    setLoading(true);
    setSearched(true);

    try {
      const res = await axiosFetch.post("/customers/search", {
        firstName: values.name,
        email: values.email,
        phoneNumber: values.phone,
      });

      console.log("API RESPONSE:", res.data);

      const customers = res.data?.data || res.data || [];

      setData(Array.isArray(customers) ? customers : []);
      setPage(1);
    } catch (error) {
      console.log("Error fetching customers", error);
    } finally {
      setLoading(false);
    }
  };


useEffect(() => {
  fetchCustomers({ name: "", email: "", phone: "" });
}, []);
  ;

  // Pagination
  const paginatedData = data.slice(
    (page - 1) * pageSize,
    page * pageSize
  );

  // Columns
  const columns = [
    {
      accessor: "index",
      title: "ID",
      render: (_, index) => (page - 1) * pageSize + index + 1,
    },
    // { accessor: "customerId", title: "ID" },
    { accessor: "firstName", title: " Name" },
 
    { accessor: "email", title: "Email" },
    { accessor: "phoneNumber", title: "Phone" },
    {
      accessor: "messaageString",
      title: "Message",
      render: (row) => row.messaageString || "-",
    },
    { accessor: "registerDateTime", title: "Registered At" },

    
    
  ];

  const fields = [
    { label: "Name", name: "name" },
    { label: "Email", name: "email" },
    { label: "Phone", name: "phone" },
  ];

  return (
    <Container size="lg" py={40}>
      <Title mb={20}>Customer Search</Title>

      <Formik
        initialValues={{ name: "", email: "", phone: "" }}
        onSubmit={fetchCustomers}
      >
        {({ values, handleChange }) => (
          <Form>
            {/* Form */}
            <Card shadow="md" p="lg" mb={20}>
              <Box
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "16px",
                  alignItems: "flex-end",
                }}
              >
                {fields.map((field) => (
                  <TextInput
                    key={field.name}
                    label={field.label}
                    name={field.name}
                    value={values[field.name]}
                    onChange={handleChange}
                    style={{ flex: "1 1 200px" }}
                  />
                ))}
                <Button type="submit">Search</Button>
              </Box>
            </Card>

            {/* Table */}
           <Card shadow="md" p="lg">
  {loading ? (
    <Loader />
  ) : !searched ? (
    <div style={{ textAlign: "center" }}>
      Search customers to see results
    </div>
  ) : data.length === 0 ? (
    <div style={{ textAlign: "center", padding: "20px" }}>
      No customers found
    </div>
  ) : (
    <DataTable
      withBorder
      borderRadius="sm"
      striped
      highlightOnHover
      records={paginatedData}
      columns={columns}
      totalRecords={data.length}
      recordsPerPage={pageSize}
      page={page}
      onPageChange={setPage}
      recordsPerPageOptions={[5, 20, 50]}
      onRecordsPerPageChange={(size) => {
        setPageSize(size);
        setPage(1);
      }}

      // ✅ remove default empty UI
      noRecordsText=""

      paginationText={({ from, to, totalRecords }) =>
        `${from} - ${to} of ${totalRecords} records`
      }

      styles={{
        pagination: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingTop: "12px",
        },
      }}
    />
  )}
</Card>
          </Form>
        )}
      </Formik>
    </Container>
  );
}